import BuildingEnergyPage from "./BuildingEnergyPage";

export default BuildingEnergyPage;
